// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"1a3194ef","30":"7a805187","79":"0e9467c9","82":"e6e4f68b","216":"7c5d0ee8","324":"18cfaffd","349":"f95edbd3","402":"eb233c14","495":"c51bcadf","658":"9a151319","738":"70eaaf99","756":"d59c6164","843":"6b1ac028","876":"edefd14d"}[chunkId] + ".chunk.js";
};